export default "__VITE_ASSET__5655842e__"